import { ActivityService } from '../../../services/activity/activity.service';
import { UIService } from '../../../services/ui/ui.service';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import { AgendaFooterService } from '../../../services/footer/agenda-footer.service';
import { EventsService } from '../../../services/events/events.service';
import { IndHeaderLeftDataModel } from "@omni/models/indHeaderLeftDataModel";
import { TranslateService } from "@ngx-translate/core";
import { IndTabsDataModel } from "@omni/models/ind-tabs-data-model";
import { IndSectionHeaderViewDataModel } from "@omni/models/indSectionHeaderDataModel";
import { MyAssistantService, NOTIFICATION } from "@omni/services/my-assistant/my-assistant.service";
import { DateTimeFormatsService } from "@omni/services/date-time-formats/date-time-formats.service";
import { MultiSelectPopover } from "@omni/components/multi-select-popover/multi-select-popover";
import { PopoverController } from "@ionic/angular";
import { TrackingEventNames, TrackService } from "@omni/services/logging/tracking.service";
import { IndNotificationDataModel } from "@omni/models/indNotificationDataModel";
import { NavigationService, PageName } from "@omni/services/navigation/navigation.service";
import {of, Subject, Subscription} from "rxjs";
import { EmailActivity, EmailViewType } from '@omni/classes/activity/email.activity.class';
import { EmailService } from '@omni/services/email-templates/email.service';
import { NotificationService, ToastStyle } from '@omni/services/notification/notification.service';
import { AppointmentActivity } from '@omni/classes/activity/appointment.activity.class';
import { AccesingMode, CaseManagementService } from '@omni/services/case-management/case-management.service';
import { CaseActivity } from '@omni/classes/case-intake/case-activity.class';
import { FooterService, FooterViews } from '@omni/services/footer/footer.service';
import { DynamicFormType } from '@omni/models/dynamic-form-component.model';
import { MdmService } from '@omni/services/mdm/mdm.service';
import { DynamicForm, FormType } from '@omni/classes/dynamic-form/dynamic-form.class';
import { DynamicFormsService } from '@omni/services/dynamic-forms/dynamic-forms-service';
import { AllocationFeatureService } from '@omni/services/sample/allocation.feature.service';
import { TransferType, AdjustmentStatus } from '@omni/enums/allocation/allocation.enum';
import { IAllocationAdjustment } from '@omni/interfaces/allocation/allocation-adjustment.interface';
import { AllocationShipmentService } from '@omni/services/sample/allocation-shipment.service';
import { ContactOfflineService } from '@omni/services/contact/contact.service';
import { AccountOfflineService } from '@omni/services/account/account.offline.service';
import { FollowUpActivity, FOLLOW_UP_TYPE } from '@omni/classes/activity/follow-up-action.activity.class';
import { AuthenticationService } from '@omni/services/authentication.service';
import { ActivityDataService } from '@omni/data-services/activity/activity.service';
import { DatePipe } from '@angular/common';
import { DeviceService } from '@omni/services/device/device.service';
import { OrderManagementService } from '@omni/services/order-management/order-management.service';
import { OrderActivity } from '@omni/classes/activity/order.activity.class';
import { FeatureActionsService } from '@omni/services/feature-actions/feature-actions.service';
import { switchMap, takeUntil, tap} from "rxjs/operators";
import {QuotesService} from "@omni/services/quote/quote-tool.service";
import {Quotes, QuoteStatus} from "@omni/classes/quotes/quotes.class";
import { SampleDeliveryRequestService } from "@omni/services/sample/sample-delivery-request.service";
import { SampleDeliveryRequest, buildSdrStatusNotificationModel } from "@omni/classes/sample/sample-delivery-request.class";
import { SecInfoConfigDataService } from "@omni/data-services/sec-info-config/sec-info-config-data-service";
import { FeatureActionsMap } from "@omni/classes/authentication/user.class";
import { every, filter, findIndex, isEmpty, some } from 'lodash-es';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'notification-list',
  templateUrl: 'notification-list.html',
  styleUrls: ['notification-list.scss'],
  standalone: true,
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationListComponent implements OnInit, OnDestroy {

  tabs: IndTabsDataModel[] = [];
  public rawNotifications: Array<IndNotificationDataModel> = new Array<IndNotificationDataModel>();
  public notifications: Array<IndNotificationDataModel> = new Array<IndNotificationDataModel>();
  public filteredNotifications: Array<IndNotificationDataModel> = new Array<IndNotificationDataModel>();
  public visibleNotifications: Array<IndNotificationDataModel> = new Array<IndNotificationDataModel>();
  allNotificationsSectionHeader: IndSectionHeaderViewDataModel;
  private itemExpandHeight: number = 25;
  private visibleCount: number = 0;
  actionPopoverData: ({ text: string; expanded: boolean; value: string; items: { text: string; value: string; asc: boolean; }[]; handler: (selectedItem: any, item: any) => void; })[] | ({ text: string; value: string; items: { text: String; value: String; }[]; handler: (selectedItem: any, item: any) => void; expanded?: undefined; })[];
  private filterPopoverData;
  private IallNotificationsSubscription: Subscription;
  private IcurrentNotifSubscription: Subscription;
  private itemSelected: IndNotificationDataModel = null;
  private selectedFilterByValue = 'all';
  private selectedCustomFilterByValue = 'all';
  private filterActived = false;
  private ngDestroy$ = new Subject<boolean>();
  private isSearching:boolean = false;
  private searchValue:string = '';
  @Input() from: string;

  constructor(
    public uiService: UIService,
    public activityService: ActivityService,
    public agendaFooterService: AgendaFooterService,
    public eventService: EventsService,
    public translate: TranslateService,
    public myAssistantService: MyAssistantService,
    public dateTimeFormatsService: DateTimeFormatsService,
    private popoverCtrl: PopoverController,
    private trackingService: TrackService,
    public navService: NavigationService,
    public emailService: EmailService,
    private contactService: ContactOfflineService,
    private accountService: AccountOfflineService,
    private notificationService: NotificationService,
    public events: EventsService,
    private caseManagementService: CaseManagementService,
    public footerService: FooterService,
    public mdmService: MdmService,
    private dynamicFormsService: DynamicFormsService,
    public allocFeatureService: AllocationFeatureService,
    public allocationShipmentService: AllocationShipmentService,
    public authenticationService: AuthenticationService,
    public activityDataService: ActivityDataService,
    private datePipe: DatePipe,
    private readonly device: DeviceService,
    private readonly orderManagementService: OrderManagementService,
    public assistantService: MyAssistantService,
    public faService: FeatureActionsService,
    private quotesService: QuotesService,
    private sdrService: SampleDeliveryRequestService,
    private readonly secInfoConfigDataService: SecInfoConfigDataService,
    private readonly _cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getNotificationData();
    this.IallNotificationsSubscription = this.myAssistantService.notificationsObs$.subscribe((data: IndNotificationDataModel[]) => {
      if (data) {
        const sdrFaOn = this.authenticationService.hasFeatureAction(FeatureActionsMap.SAMPLE_DELIVERY_REQUESTS);
        const filtered = sdrFaOn
          ? data
          : data.filter(n => n.type !== NOTIFICATION.SAMPLE_DELIVERY_REQUEST_STATUS_CHANGED);
        this.notifications = [...filtered];
        this.rawNotifications = filtered;
        this.myAssistantService.hasAnyUnRedNotifications = some(filtered, ['isRed', false]);
        if (!this.filterActived) {
          this.filteredNotifications = this.visibleNotifications =  this.notifications;
          this.sortNotifications(this.visibleNotifications);
          this.groupCustomNotification(this.visibleNotifications)
        }
        this.setFilteredNotifications();
        this.sortNotifications(this.filteredNotifications);
        this.updateVisibleRecords();
        this.initAllNotificationsHeader();
        this._cd.markForCheck();
      }
    });
    this.updateVisibleRecords();
    this.IcurrentNotifSubscription = this.myAssistantService.selectedNotificationObs$.subscribe((model: IndNotificationDataModel) => {
      this.itemSelected = model;
      this._cd.markForCheck();
    });
    this.tabs = this.uiService.getAgendaTabs();
    this.translate.onLangChange.pipe(takeUntil(this.ngDestroy$)).subscribe(data => {
      this.tabs = this.uiService.getAgendaTabs();
      this._cd.markForCheck();
    });
    this.initAllNotificationsHeader();
    this.actionPopoverData = [
      {
        text: "",
        expanded: true,
        value: "title",
        items: [
          { text: this.translate.instant('MARK_ALL_AS_READ'), value: "markallread", asc: false },
          { text: this.translate.instant('CLEAR_ALL'), value: "clearall", asc: false }
        ],
        handler: async (selectedItem, item) => {
          item.value = selectedItem.value;
          if (item.value == 'clearall') {
            this.trackingService.tracking('NotificationClearAll', TrackingEventNames.NOTIFICATIONS);
            await this.clearAllNotifications();
          } else {
            this.trackingService.tracking('NotificationReadAll', TrackingEventNames.NOTIFICATIONS);
            await this.markAllRedNotifications();
          }
          this.updateVisibleRecords();
          this.initAllNotificationsHeader();
          this.popoverCtrl.dismiss();
        }
      }
    ];
    this.filterPopoverData = [
      {
        text: "",
        value: "all",
        selectedValues: ["all"],
        items: [
          { text: this.translate.instant('ALL'), value: "all" },
          { text: this.translate.instant('SYSTEM_NOTIFICATION'), value: "system-notification" }],
        handler: (selectedItem, item, itemRef) => {
          // if(selectedItem.value == 'all') {
            itemRef.parent.items.map((o) => {
              o.value = '';
            })
          // }
          item.value = selectedItem.value;
          this.selectedFilterByValue = selectedItem.value;
          this.selectedCustomFilterByValue = '';
          if (selectedItem.value) {
            this.applyCustomNotificationFiler(this.notifications, this.selectedFilterByValue, this.selectedCustomFilterByValue)
          }
          this.updateVisibleRecords();
          this.initAllNotificationsHeader();
          // OnPush: handler fires from the popover, so this component is never marked dirty on its own.
          // Without this, the filtered list only repaints on the next notifications emission (perceived lag / "click twice").
          this._cd.markForCheck();
          this.popoverCtrl.dismiss();
        },
      },
      {
        text: this.translate.instant('FEED'),
        expanded: true,
        value: '',
        items: [
          { text: this.translate.instant('ALL_FEEDS'), value: "all-feeds" },
          { text: this.translate.instant('R_WEB'), value: 'web' },
          { text: this.translate.instant('App'), value: 'app' },
          { text: this.translate.instant('EVENT'), value: 'event' },
          { text: this.translate.instant('E_LEARNING'), value: 'learning' },
        ],
        handler: (selectedItem, item, itemRef) => {
          itemRef.parent.items[0].value = '';
          item.value = item.value === selectedItem.value ? "" : selectedItem.value;
          this.selectedFilterByValue = '';
          this.selectedCustomFilterByValue = selectedItem.value;
          if (selectedItem.value) {
            this.applyCustomNotificationFiler(this.notifications, this.selectedFilterByValue, this.selectedCustomFilterByValue)
          }
          this.updateVisibleRecords();
          this.initAllNotificationsHeader();
          // OnPush: handler fires from the popover, so this component is never marked dirty on its own.
          // Without this, the filtered list only repaints on the next notifications emission (perceived lag / "click twice").
          this._cd.markForCheck();
          this.popoverCtrl.dismiss();
        }
      }
    ]
    if(this.from !== 'homePage') {
      this.activityService.selectedActivity = undefined;

    }
  }

  ngOnDestroy() {
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
    if (this.IallNotificationsSubscription) this.IallNotificationsSubscription.unsubscribe();
    if (this.IcurrentNotifSubscription) this.IcurrentNotifSubscription.unsubscribe();
  }

  private getNotificationData() {
    this.quotesService.quotesList$.pipe(
      takeUntil(this.ngDestroy$),
      switchMap(quotes => {
        if (quotes.length === 0) {
          return of([]);
        }
        return of(quotes);
      }),
      tap((quotes: Quotes[]) => {
        quotes.forEach(quote => {
          if (quote.statuscode === QuoteStatus.APPROVED || quote.statuscode === QuoteStatus.REJECTED) {
            const quoteName = quote.name;
            const notificationType = quote.statuscode === QuoteStatus.APPROVED ? NOTIFICATION.QUOTE_APPROVED_NOTIFICATION : NOTIFICATION.QUOTE_REJECTED_NOTIFICATION;
            const notificationName = this.translate.instant(notificationType, {quoteName: quoteName});

            this.myAssistantService.createCustomNotification({
              type: notificationType,
              name: notificationName,
              DateTime: new Date(quote.lastUpdated).getTime(),
              id: notificationType + quote.ID,
              data: quote,
              icon: 'assets/imgs/quotes_notification.svg',
              isRed: false,
              params: {quoteName}
            });
          }
        });
      })
    ).subscribe();

    if (this.authenticationService.hasFeatureAction(FeatureActionsMap.SAMPLE_DELIVERY_REQUESTS)) {
    this.sdrService.allSdrs$.pipe(
      takeUntil(this.ngDestroy$),
      switchMap(sdrs => (sdrs.length === 0 ? of([]) : of(sdrs))),
      tap((sdrs: SampleDeliveryRequest[]) => {
        sdrs.forEach(sdr => {
          const model = buildSdrStatusNotificationModel(sdr);
          if (!model) return;
          // The autonumber title already carries the "Sample Request" prefix +
          // HCP name; when Dynamics returns no title, fall back to a translated
          // "Sample Request <id>" so the message never renders a bare GUID.
          const params = {
            ...model.params,
            requestId: sdr.title && sdr.title.trim()
              ? this.secInfoConfigDataService.stripSdrTitleTrailingSeparator(sdr.title)
              : `${this.translate.instant('SAMPLE_REQUEST')} ${sdr.id}`,
          };
          this.myAssistantService.createCustomNotification({
            type: model.type,
            name: this.translate.instant(model.type, params),
            DateTime: model.DateTime,
            id: model.id,
            data: model.data,
            icon: 'assets/imgs/selected-sample-delivery-request-icon.svg',
            isRed: false,
            params,
          });
        });
      })
    ).subscribe();
    } // end FA guard

  }

  trackByNotificationId(index: number, notification: IndNotificationDataModel) {
    return notification?.id;
  }

  groupCustomNotification(allNotification) {
    const modifiedNotification = [];
    const customNotificationMap = new Map();

    for (const notificationObj of allNotification) {
      if(!notificationObj) continue;
      if (notificationObj.type === NOTIFICATION.CUSTOM_NOTIFICATION) {
        const contactId = notificationObj.data.contactId;
        if (!customNotificationMap.has(contactId)) {
          customNotificationMap.set(contactId, []);
        }
        customNotificationMap.get(contactId).push(notificationObj);
      } else {
        modifiedNotification.push(notificationObj);
      }
    }

    for (const [contactId, notifications] of customNotificationMap.entries()) {
      if (notifications.length === 1) {
        modifiedNotification.push(notifications[0]);
      } else {
        const parentNotification = { ...notifications[0], childNotifications: [] };
        for (const notification of notifications) {
          const notificationCopy = { ...notification, handleItemClick: async (id: string, event, specificTarget) => await this.openActivityDetails(id) };
          parentNotification.childNotifications.push(notificationCopy);
        }
        modifiedNotification.push(parentNotification);
      }
    }

    this.filteredNotifications = this.visibleNotifications = modifiedNotification;
  }

  private _getFormattedDate(date) {
    return this.datePipe.transform(date, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
  }

  // private _getFormattedCustomNotificationDate(date) {
  //   return this.datePipe.transform(date, "dd-MM-yyyy , h:mm a");
  // }

  mapNotificationMainCard(data) {
    let clickHandler = async (id: string, event, specificTarget) => {
      await this.openActivityDetails(id);
    };
    // The SDR icon is a real asset path; render it via [src] rather than the
    // `notification-`-prefixed [name] (which resolves to a non-served path and
    // silently shows nothing). isSrcAttribute also flips the start (blue-dot)
    // icon to [src], whose path is served too — so no regression there.
    const isSdr = data.type === NOTIFICATION.SAMPLE_DELIVERY_REQUEST_STATUS_CHANGED;
    // Saved notifications keep the icon path they were stored with.
    const iconByType = {
      [NOTIFICATION.NEW_SEARCH_ADV_SEARCH]: 'assets/imgs/shared_search.svg',
      [NOTIFICATION.NEW_PRESENTATIONS_NOTIFICATION]: 'assets/imgs/presentation_notification.svg',
      [NOTIFICATION.NEW_RESOURCES_NOTIFICATION]: 'assets/imgs/resource_notification.svg',
      [NOTIFICATION.QUOTE_APPROVED_NOTIFICATION]: 'assets/imgs/quotes_notification.svg',
      [NOTIFICATION.QUOTE_REJECTED_NOTIFICATION]: 'assets/imgs/quotes_notification.svg',
    };
    const icon = iconByType[data.type] ?? data.icon;
    return {
      id: data.dbKey,
      fixedHeight: true,
      isExpandable: true,
      isExpanded: true,
      expandableViewType: 'notificationList',
      expandableData: data.data,
      expandHeight: this.itemExpandHeight,
      noSeparationLine: false,
      isSelected: this.getSelectedItem(data),
      primaryTextRight: this.translate.instant(data.type, data.params),
      secondaryTextRight: data.childNotifications?null:this._getFormattedDate(new Date(data.DateTime)),//format(data.DateTime, this.dateTimeFormatsService.dateTimeToUpper),
      tertiaryTextRight:data?.data?.indskr_description,
      isShowTertiaryTextRight:(data.type==NOTIFICATION.CUSTOM_NOTIFICATION)?true:false,
      showArrow: false,
      showIcon: true,
      iconName: isSdr ? icon : (icon ? 'notification-' + icon : null),
      isSrcAttribute: isSdr,
      clickHandler: clickHandler,
      date: new Date(data.DateTime),//this._getFormattedDate(new Date(data.DateTime)),
      showStartIcon: !data.isRed,
      startIconName: "indegene-assets/imgs/notification_bluedot.svg",
      isShowChildNotification: data.childNotifications?true:false,
      childNotifications: data.childNotifications?data.childNotifications:null
    };
  }

  getSelectedItem(data):boolean{
    let returnResult =false
    if(data.type==NOTIFICATION.CUSTOM_NOTIFICATION && this.itemSelected && data.childNotifications){
      let isPresent = data.childNotifications.findIndex(notification=>notification.dbKey == this.itemSelected.dbKey)
      if(isPresent>=0) returnResult = true
    }else{
      returnResult = this.itemSelected && (this.itemSelected.dbKey == data.dbKey)
    }

    return returnResult;
  }

  async openActivityDetails(id: string) {
    let notification = this.notifications.find(e => e.dbKey === id);
    await this.myAssistantService.markReadNotification(notification);
    if (notification.type !== NOTIFICATION.SAMPLE_DELIVERY_REQUEST_STATUS_CHANGED) {
      this.myAssistantService.selectedNotification.next(notification);
    } else {
      // The broadcast above is what normally feeds itemSelected (see the
      // selectedNotificationObs$ subscription), and getSelectedItem drives the
      // row highlight off it. Suppressing it for SDR to stop a still-mounted
      // NotificationDetailsComponent misreporting missing data therefore also
      // froze the highlight on whichever row was clicked last, so an SDR
      // notification never showed as selected (OMNI-61591). Set the selection
      // directly instead — same end state for this list, without re-arming the
      // listener the suppression exists to silence.
      this.itemSelected = notification;
    }
    let data = notification.data;
    if (notification.type === NOTIFICATION.NEW_CONTACTS_NOTIFICATION) {
      let newContacts = filter(this.contactService.contacts, (con) => {
        return findIndex(data.data, (e) => {
          return con.ID == e
        }) >= 0;
      });
      if (!newContacts.length) {
        this.showNoDataBanner();
        return;
      }
    }
    if (notification.type === NOTIFICATION.NEW_ACCOUNTS_NOTIFICATION) {
      let newAccounts = filter(this.accountService.accounts, (acc) => {
        return findIndex(data.data, (e) => {
          return acc.id == e
        }) >= 0;
      });
      if (!newAccounts.length) {
        this.showNoDataBanner();
        return;
      }
    }
    switch (notification.type) {
      case NOTIFICATION.NEW_SEARCH_ADV_SEARCH:
      case NOTIFICATION.SERVICE_ERR:
      case NOTIFICATION.SYNC_FAILED:
      case NOTIFICATION.DATA_UPLOAD_ERR_FOLLOWUP:
      case NOTIFICATION.NEW_CONTACTS_NOTIFICATION:
      case NOTIFICATION.NEW_ACCOUNTS_NOTIFICATION:
      case NOTIFICATION.NEW_RESOURCES_NOTIFICATION:
      case NOTIFICATION.MISSED_CALL:
      case NOTIFICATION.NEW_PRESENTATIONS_NOTIFICATION:
      case NOTIFICATION.ASSET_REMOVED:
      case NOTIFICATION.CALL_PLAN_UPDATES_NOTIFICATION:
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        if (this.navService.getActiveChildNavViewPageName() != PageName.NotificationDetailsComponent) {
          await this.navService.pushChildNavPageWithPageTracking(PageName.NotificationDetailsComponent, PageName.NotificationDetailsComponent, PageName.NotificationListComponent);
        }
        break;

      case NOTIFICATION.CONTACT_CHANGE_REQUEST_STATUS:
      case NOTIFICATION.BUSINESS_CHANGE_REQUEST_SUBMITTED:
      case NOTIFICATION.BUSINESS_ACCOUNT_CHANGE_REQUEST_SUBMITTED:
      case NOTIFICATION.BUSINESS_CHANGE_REQUEST_OPEN:
      case NOTIFICATION.BUSINESS_CHANGE_REQUEST_APPROVED:
      case NOTIFICATION.BUSINESS_CHNAGE_REUEST_REJECTED:
      case NOTIFICATION.BUSINESS_ACCOUNT_CHANGE_REQUEST_OPEN:
      case NOTIFICATION.BUSINESS_ACCOUNT_CHANGE_REQUEST_APPROVED:
      case NOTIFICATION.BUSINESS_ACCOUNT_CHANGE_REQUEST_REJECTED:
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        await this.navService.setChildNavRoot(PageName.NotificationDetailsComponent, PageName.NotificationDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppActivitiesPageComponent });
        break;
      case NOTIFICATION.DCR_FOR_APPROVAL:
        const dcr = this.contactService.approvableDCRRequests.find(dcr => dcr.ID === data?.data.ID);
        if (!dcr || dcr.approvalStatus != 'Pending') {
          this.notificationService.notify(this.translate.instant('DATA_NO_LONGER_EXIST'), 'Notification Details', 'top', ToastStyle.DANGER);
          return;
        }
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        await this.navService.setChildNavRoot(PageName.NotificationDetailsComponent, PageName.NotificationDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppActivitiesPageComponent });
        break;
      case NOTIFICATION.ONE_KEY_CHANGE_REQUEST_STAGED:
      case NOTIFICATION.ONECRM_DCR_REQUEST_STAGED:
      case NOTIFICATION.ONECRM_UPDATE_DCR_REQUEST_STAGED:
      case NOTIFICATION.ONE_KEY_CHANGE_REQUEST_SUBMITTED:
      case NOTIFICATION.ONE_KEY_APPROVAL_AND_NEW_CONTACT_ADDEDD:
      case NOTIFICATION.ONE_KEY_REJECTED_SEE_COMMENTS:
      case NOTIFICATION.ONE_KEY_CHANGE_REQUEST_UPDATE_STAGED:
      case NOTIFICATION.ONE_KEY_CHNAGE_REQUEST_UPDATE_REQUEST_SUBMITTED:
      case NOTIFICATION.ONE_KEY_CHANGE_REQUEST_UPDATE_APPROVED_CONTACT_BE_UPDATED:
      case NOTIFICATION.ONECRM_DCR_APPROVED:
      case NOTIFICATION.ONECRM_DCR_REJECTED:
      case NOTIFICATION.ONE_KEY_CHANGE_REQUEST_UPDATE_REJECTED_SEE_COMMENTS:
      case NOTIFICATION.ONE_KEY_CHANGE_REQUEST_IN_PROCESS:
      case NOTIFICATION.ONE_KEY_CHANGE_REQUEST_SUCCESSFULLY_SUBMITTED:
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        await this.navService.setChildNavRoot(PageName.NotificationDetailsComponent, PageName.NotificationDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppActivitiesPageComponent });
        break;
      case NOTIFICATION.MESSAGE_OPENED:
      case NOTIFICATION.MESSAGE_ATTACHMENT_CLICKED:
      case NOTIFICATION.MESSAGE_SENT:
      case NOTIFICATION.MESSAGE_NOT_DELEVERED:
      case NOTIFICATION.DATA_UPLOAD_ERR_MESSAGE:
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        this.emailService.viewType = EmailViewType.FROM_AGENDA;
        this.activityService.selectedActivity = this.activityService.getActivityByID(data['activityid'] || data['offlineActivityId']);
        this.showNoDataBanner();
        this.navService.setChildNavRightPaneView(true);
        this.emailService.selectedActivity = <EmailActivity>this.activityService.selectedActivity;
        await this.navService.setChildNavRoot(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppActivitiesPageComponent });
        break;
      case NOTIFICATION.DATA_UPLOAD_ERR_MEETING:
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        this.activityService.selected = (this.activityService.getActivityByID(data.offlineMeetingId) as AppointmentActivity);
        this.showNoDataBanner();
        await this.navService.setChildNavRoot(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.GoAppActivitiesPageComponent);
        break;
      case NOTIFICATION.NEW_FOLLOW_UP_NOTIFICATION:
        this.uiService.activeView = "ActivitiesPageRightPaneNav";
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        this.activityService.selectedActivity = (this.activityService.getActivityByID(data.ID) as FollowUpActivity);
        this.showNoDataBanner();
        const followupActivity: FollowUpActivity = (this.activityService.getActivityByID(data.ID) as FollowUpActivity);
        if (followupActivity?.scientificPlanId || followupActivity?.planType === FOLLOW_UP_TYPE.SCIENTIFIC_PLAN) {
          await this.navService.setChildNavRoot(PageName.ScientificPlanFollowUpTask, PageName.ScientificPlanFollowUpTask, PageName.GoAppActivitiesPageComponent, { from: PageName.NotificationListComponent, activity: followupActivity });
        } else {
          await this.navService.setChildNavRoot(PageName.FollowUpActionDetailComponent, PageName.FollowUpActionDetailComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.NotificationListComponent });
        }
        this.footerService.initButtons(FooterViews.FollowUpDetails);
        break;
      case NOTIFICATION.INQUIRY_STATUS:
        let caseActivity: CaseActivity = this.caseManagementService.myCases.find(a => a.ID == data.incidentid);
        if (!caseActivity) {
          this.notificationService.notify(this.translate.instant('DATA_NO_LONGER_EXIST'), 'Notification Details', 'top', ToastStyle.DANGER);
          return;
        }
        try {
          this.navService.setChildNavRightPaneView(true);
          this.caseManagementService.accessedFrom = AccesingMode.AGENDA;
          this.caseManagementService.assignSelectedCase(caseActivity);
        } catch (error) {
          // Silently handle incident fetch failure from notifications
        }
        this.uiService.activeView = "ActivitiesPageRightPaneNav";
        await this.navService.setChildNavRoot(PageName.CaseManagementDetailComponent, PageName.CaseManagementDetailComponent, PageName.GoAppActivitiesPageComponent);
        this.footerService.initButtons(FooterViews.CUSTOMER_INQUIRY);
        break;
      case NOTIFICATION.CONTACT_CHANGE_REQUEST_STATUS:
        let contactForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("indskr_contactcr", FormType.DISPLAYFORM);
        this.mdmService.currentSelected.next(data);
        this.uiService.activeView = 'ContactPageRightPaneNav';
        this.uiService.showNewActivity = false;
        this.navService.setChildNavRightPaneView(true);
        await this.navService.pushChildNavPageWithPageTracking(PageName.CrDetailsComponent, PageName.CrDetailsComponent, PageName.ContactPageComponent, {
          from: 'Contact',
          displayFormDetails: contactForm,
          dynamicFormType: DynamicFormType.CONFIGUREDFORM
        });
        break;
      case NOTIFICATION.ACCOUNT_CHANGE_REQUEST_STATUS:
        this.mdmService.currentSelected.next(data);
        this.navService.setChildNavRightPaneView(true);
        this.uiService.showNewActivity = false;
        await this.navService.pushChildNavPageWithPageTracking(PageName.AccountCrDetailsComponent, PageName.AccountCrDetailsComponent, PageName.AccountPageComponent, {
          from: 'Account'
        });
        break;
      case NOTIFICATION.CUSTOMER_ALLOCATION_TRANSFER:
        let transfer = data;
        this.allocFeatureService.selectedShipment = transfer;
        this.allocFeatureService.selectedShipmentAtHome = this.allocFeatureService.selectedShipment;
        this.uiService.activeView = "ActivitiesPageRightPaneNav";
        this.uiService.prevView = this.uiService.activeView;
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        this.allocationShipmentService.fromAgendaPlanTab = true;
        if (transfer.indskr_transfertype == TransferType.AllocationTransfer) {

          this.allocationShipmentService.newShipmentSelectedFromList$.next(PageName.AllocationComponent);
          this.navService.setChildNavRoot(PageName.AllocationShipmentDetailsComponent, PageName.AllocationShipmentDetailsComponent, PageName.GoAppActivitiesPageComponent);
        }
        break;
      case NOTIFICATION.CUSTOM_NOTIFICATION:
        let customNotifications = data;
        this.uiService.activeView = "ActivitiesPageRightPaneNav";
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        this.navService.setChildNavRoot(PageName.CustomNotificationDetails, PageName.CustomNotificationDetails, PageName.GoAppActivitiesPageComponent, { from: 'AgendaView', activity: customNotifications });
        break;
      case NOTIFICATION.NOTIFICATION_TO_COVISITOR:
        let activity = data;
        this.uiService.activeView = "ActivitiesPageRightPaneNav";
        this.uiService.prevView = this.uiService.activeView;
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        this.activityService.selectedActivity = this.activityService.getActivityByID(activity.ID) as AppointmentActivity
        this.activityDataService.updateActivityDetails(activity);
        if (this.activityService.selectedActivity) {
          await this.navService.setChildNavRoot(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.GoAppActivitiesPageComponent);
        } else {
          await this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, PageName.NotificationListComponent)
          this.showMeetingNoDataBanner(activity);

        }
        break;
      case NOTIFICATION.ADJUSTMENT_REJECTED:
        let shipment = data;
        this.allocFeatureService.selectedShipment = shipment;
        this.uiService.activeView = "ActivitiesPageRightPaneNav";
        this.navService.setChildNavRightPaneView(true);
        if (shipment.indskr_transfertype === TransferType.AllocationAdjustment) {
          // Adjustment
          if ((shipment as IAllocationAdjustment).indskr_adjustedstatus === AdjustmentStatus.Open) {
            this.allocationShipmentService.isNewAdjustment = false;
            this.allocationShipmentService.newAdjustmentSelectedFromList$.next(true);
            await this.navService.setChildNavRoot(PageName.AllocationShipmentDetailsComponent, PageName.AllocationShipmentDetailsComponent, PageName.GoAppActivitiesPageComponent);
          } else {
            this.allocationShipmentService.newShipmentSelectedFromList$.next(PageName.AllocationComponent);
            await this.navService.setChildNavRoot(PageName.AllocationShipmentDetailsComponent, PageName.AllocationShipmentDetailsComponent, PageName.GoAppActivitiesPageComponent);
          }
        } else {
          // Shipment or Transfer
          this.allocationShipmentService.newShipmentSelectedFromList$.next(PageName.AllocationComponent);
          await this.navService.setChildNavRoot(PageName.AllocationShipmentDetailsComponent, PageName.AllocationShipmentDetailsComponent, PageName.GoAppActivitiesPageComponent);
        }
        break;
      case NOTIFICATION.NEW_TEAM_ORDER_NOTIFICATION:
        if (!this.device.isOffline) {
          this.uiService.displayLoader();
          let foundOrder = new OrderActivity({
            salesorderid: data.id,
            ordernumber: data.data,
            activitytypecode: 'indskr_order'
          })
          await this.activityDataService.getRealTimeActivityDetails(foundOrder).then(newOrder => {
            this.orderManagementService.selectedOrder = newOrder as OrderActivity;
            this.activityService.selectedActivity = newOrder as OrderActivity;
            this.uiService.activeView = "ActivitiesPageRightPaneNav";
            this.uiService.showNewActivity = false;
            this.uiService.showRightPane = true;
            this.navService.setChildNavRightPaneView(true);
            this.navService.setChildNavRoot(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: 'AgendaView', activity: newOrder });
          });
          this.uiService.dismissLoader();

        } else {
          this.notificationService.notify(this.translate.instant('TEAM_SALES_ORDER_OFFLINE_NOTIFICATION'), 'Notification Details', 'top', ToastStyle.DANGER);
        }
        break;
      case NOTIFICATION.CUSTOMER_POSITION_LIST_SUBMITTED:
      case NOTIFICATION.CUSTOMER_POSITION_LIST_APPROVED:
      case NOTIFICATION.CUSTOMER_POSITION_LIST_REJECTED:
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        await this.navService.pushChildNavPageWithPageTracking(PageName.NotificationDetailsComponent, PageName.NotificationDetailsComponent, PageName.NotificationListComponent);
        break;
      case NOTIFICATION.APPEAL_STATUS_SUBMITTED:
      case NOTIFICATION.APPEAL_STATUS_APPROVED:
      case NOTIFICATION.APPEAL_STATUS_REJECTED:
      case NOTIFICATION.APPEAL_STATUS_PENDING_FOR_SUBMISSION:
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        await this.navService.pushChildNavPageWithPageTracking(PageName.NotificationDetailsComponent, PageName.NotificationDetailsComponent, PageName.NotificationListComponent);
        break;
      case NOTIFICATION.QUOTE_APPROVED_NOTIFICATION:
      case NOTIFICATION.QUOTE_REJECTED_NOTIFICATION:
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.setChildNavRightPaneView(true);
        await this.navService.pushChildNavPageWithPageTracking(PageName.NotificationDetailsComponent, PageName.NotificationDetailsComponent, PageName.NotificationListComponent);
        break;
      case NOTIFICATION.SAMPLE_DELIVERY_REQUEST_STATUS_CHANGED: {
        // `data` is the SampleDeliveryRequest itself (notification.data === sdr).
        // Prefer the fuller device-cached copy if it's still around.
        const cached = this.sdrService.allSdrs.find(s => s.id === data?.id);
        const sdr: SampleDeliveryRequest = cached ?? data;
        this.uiService.showNewActivity = false;
        this.navService.setChildNavRightPaneView(true);
        this.uiService.showRightPane = true;
        await this.navService.setChildNavRoot(
          PageName.SampleDeliveryRequestDetailComponent,
          PageName.SampleDeliveryRequestDetailComponent,
          PageName.GoAppNotificationPageComponent,
          { sdr, from: PageName.NotificationListComponent },
        );
        break;
      }
      default:
        break;
    }
  }

  showNoDataBanner() {
    if (!this.activityService.selectedActivity) {
      this.notificationService.notify(this.translate.instant('DATA_NO_LONGER_EXIST'), 'Notification Details', 'top', ToastStyle.DANGER);
      return;
    }
  }

  showMeetingNoDataBanner(activity) {
    if (!this.activityService.selected || (isEmpty(activity['accompaniedUserList']) || !activity['accompaniedUserList'].find(ac => ac.indskr_user === this.authenticationService.user.systemUserID))) {
      this.notificationService.notify(this.translate.instant('THIS_MEETING_NO_LONGER_EXIST'), 'Notification Details', 'top', ToastStyle.DANGER);
      return;
    }
  }
  async clearAllNotifications() {
    if (!this.notifications.length) return;
    await this.myAssistantService.clearAllNotifications(this.filteredNotifications);
    await this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, PageName.NotificationListComponent);
  }

  async markAllRedNotifications() {
    if (every(this.filteredNotifications, ['showStartIcon', false])) return;
    await this.myAssistantService.markAllRedNotifications(this.filteredNotifications);
  }

  sortNotifications(notifications: IndNotificationDataModel[]) {
    return notifications.sort((a, b) => {
      if (new Date(a.DateTime) < new Date(b.DateTime))
        return 1;
      else
        return -1;
    });
  }

  get indHeaderLeftModel(): IndHeaderLeftDataModel {
    return {
      id: 'notification-list-header-left',
      cssClass: 'main-tool-header-title' + (this.from === 'homePage' ? ' go-app-home' : ''),
      title: this.from === 'homePage' ? this.translate.instant('SEARCH') : this.translate.instant('SEARCH_NOTIFICATIONS'),
      mode: true,
      isOnActPage: true,
      controls: [],
      fromHomePage: true
    };
  }

  initAllNotificationsHeader() {
    let titleText = `${this.translate.instant('ALL') + ' ' + this.translate.instant('NOTIFICATIONS')} (${this.filteredNotifications.length})`;
    if (this.translate.currentLang == 'es') {
      titleText = `${this.translate.instant('ALL_NOTIFICATIONS')} (${this.filteredNotifications.length})`;
    } else if (this.translate.currentLang == 'it') {
      titleText = `${this.translate.instant('NOTIFICATIONS')} (${this.filteredNotifications.length})`;
    }
    this.allNotificationsSectionHeader = {
      id: 'all-notifications-header',
      title: titleText,
      doNotModifyTitleCase: true,
      controls: [{
        id: 'clean-read-notifications',
        icon: 'assets/imgs/notifications-threedots.svg',
        isDisabled: false
      }],
    }
  }

  clearNotification(data: IndNotificationDataModel) {
    this.myAssistantService.clearNotification(data);
    this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, PageName.NotificationListComponent);
  }

  markReadNotification(data: IndNotificationDataModel) {
    if (data.isRed) return;
    this.myAssistantService.markReadNotification(data);
  }

  markUnReadNotification(data: IndNotificationDataModel) {
    if (!data.isRed) return;
    this.myAssistantService.markUnReadNotification(data);
  }

  onInput(event) {
    if (event && event.target) {
      const val = event.target.value;
      if (val && val.trim() != '') {
        this.isSearching = true;
        this.searchValue = val;
      } else {
        this.isSearching = false;
        this.searchValue = '';
      }
      this.setFilteredNotifications();
    }
    this.sortNotifications(this.filteredNotifications);
    this.updateVisibleRecords();
    this.initAllNotificationsHeader();
  }

  setFilteredNotifications() {
    if (this.isSearching) {
      this.filteredNotifications = this.notifications.filter(data => {
        return ((data.name).toLowerCase()).includes(this.searchValue.toLowerCase());
      }) as Array<IndNotificationDataModel>;
    } else {
      this.filteredNotifications = this.notifications;
    }
    if (this.filterActived) {
      this.applyCustomNotificationFiler(this.filteredNotifications, this.selectedFilterByValue, this.selectedCustomFilterByValue);
    }
  }

  onCancel(event) {
    this.isSearching = false;
    this.searchValue = '';
    this.setFilteredNotifications();
    this.sortNotifications(this.filteredNotifications);
    this.updateVisibleRecords();
    this.initAllNotificationsHeader();
  }

  onSelectedTabChange(selectedTab: string) {
    this.uiService.setAgendaTab(selectedTab);
  }

  public onSectionHeaderControlClick(id) {
    if (id == 'clean-read-notifications') {
      this.showSortPopover();
    }
  }

  async showSortPopover() {
    this.actionPopoverData[0].value = '';
    const popover = await this.popoverCtrl
      .create({ component: MultiSelectPopover, componentProps: { root: this.actionPopoverData }, event: event }).then((data) => {
        data.present();
      });
  }

  public doInfinite(event) {
    this.visibleCount = this.visibleNotifications.length;
    this.visibleNotifications.push(...this.filteredNotifications.slice(this.visibleCount, this.visibleCount + 20));
    event.target.complete();
  }

  private updateVisibleRecords() {
    this.visibleCount = 20;
    if (this.filteredNotifications.length > 20) {
      this.visibleNotifications = [...this.filteredNotifications].slice(0, this.visibleCount);
    } else {
      this.visibleNotifications = this.filteredNotifications;
    }
  }

  async openCustomNotificationFilterPopup(event) {
    this.popoverCtrl.create({ component: MultiSelectPopover, componentProps: { root: this.filterPopoverData }, cssClass: 'dropdown-list-view', event: event }).then((data) => data.present())
  }

  applyCustomNotificationFiler(filteredNotifications, slectedFilterValue: string, selectedCustomFilterByValue: string) {
    this.filterActived = true;
    if (selectedCustomFilterByValue == 'app') {
      this.filteredNotifications = filteredNotifications.filter(el => el.data['indskr_channel'] == 600000001)
    } else if (selectedCustomFilterByValue == 'web') {
      this.filteredNotifications = filteredNotifications.filter(el => el.data['indskr_channel'] == 600000000)
    } else if (selectedCustomFilterByValue == 'event') {
      this.filteredNotifications = filteredNotifications.filter(el => el.data['indskr_channel'] == 600000002)
    } else if (selectedCustomFilterByValue == 'learning') {
      this.filteredNotifications = filteredNotifications.filter(el => el.data['indskr_channel'] == 600000003)
    } else if (selectedCustomFilterByValue == 'all-feeds') {
      this.filteredNotifications = filteredNotifications.filter(el => el.type == NOTIFICATION.CUSTOM_NOTIFICATION)
    }
    if (slectedFilterValue == 'all') {
      this.filterActived = false;
      this.filteredNotifications = filteredNotifications
    } else if (slectedFilterValue == "system-notification") {
      this.filteredNotifications = filteredNotifications.filter(el => el.type != NOTIFICATION.CUSTOM_NOTIFICATION)
    }

    this.groupCustomNotification(this.filteredNotifications);
    if (this.isSearching) {
      this.filteredNotifications = this.filteredNotifications.filter(data => {
        return ((data.name).toLowerCase()).includes(this.searchValue.toLowerCase());
      }) as Array<IndNotificationDataModel>;
    }
  }

}
